module.exports = __webpack_public_path__ + "static/media/sound-icon.b72cf587.svg";